import React from 'react';
import { PostListItem } from '../../types/post-list-item.interface';
import Button from '../button/button.component';
import styles from './post-list-item.module.scss';
import Link from 'next/link';

type Props = {
  hideDetails?: boolean;
  post: PostListItem;
  baseUrl: string;
  path: string;
};

const PostsListItemComponent: React.FC<Props> = ({
  post,
  baseUrl,
  path,
  hideDetails,
}) => {
  return (
    <div className={styles.wrapper}>
      <div
        className={styles.img}
        style={{ backgroundImage: `url(${baseUrl}${post.image.url})` }}
      ></div>
      <Link href={`/${path}/${post.slug}`}>
        <a className={styles.titleLink}>{post.title}</a>
      </Link>
      {!hideDetails && (
        <>
          <h5 className={styles.meta}>
            Created at {new Date(post.createdAt).toLocaleDateString('pl')} by{' '}
            {post.author.name}
          </h5>
          <p className={styles.description}>
            {post.description.replace(/(^|[^.])\.{3}([^.]|$)/g, '')}{' '}
            <Link href={`/${path}/${post.slug}`}>
              <a>read more...</a>
            </Link>
          </p>
        </>
      )}
    </div>
  );
};

export default PostsListItemComponent;
